import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { connectRoutes } from 'redux-first-router';

import routesMap from './routesMap';
import options from './options';
import * as reducers from './reducers';

const configureStore = (preLoadedState, initialEntries) => {
	const { reducer, middleware, enhancer, ...routerProps } = connectRoutes(routesMap, {
		...options,
		initialEntries,
	});
	const middlewares = [middleware];

	middlewares.push(thunk);

	if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
		middlewares.push(
			createLogger({
				level: 'info',
				collapsed: true,
			}),
		);
	}

	const rootReducer = combineReducers({ ...reducers, location: reducer });
	const enhancers = compose(enhancer, applyMiddleware(...middlewares));
	const store = createStore(rootReducer, preLoadedState, enhancers);

	return { store, thunk: routerProps.thunk };
};

export default configureStore;
